var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showVATTip && _vm.excludingText)?_c('span',{staticClass:"VAT-tip"},[_c('span',{staticClass:"dot"},[_vm._v(",")]),_vm._v(" "+_vm._s(_vm.excludingText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }